import React from 'react';
import { CodelessIcon, ManuallyIcon } from 'tuui';
import { Radio, RadioGroup } from 'taboola-ultimate-ui';
import { useAvailableItems } from 'hooks';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ENTITY } from '../../config';
import { RecommendedBadge } from './RecommendedBadge';
import styles from './trackingSetupCodelessConversionMethodRadioGroup.module.scss';

const configs = [
    {
        id: ENTITY.CODELESS_EVENT_TOOL,
        icon: CodelessIcon,
        label: 'Codeless event tool',
        labelId: 'tracking.setup.modal.codeless_event_tool.label',
        badgeComponent: <RecommendedBadge />,
        subtext:
            'Use the codeless tool to easily set up and manage events and parameters on your website without writing any code. \n' +
            'This is the simplest way to set up conversion events.',
    },
    {
        id: ENTITY.CONVERSION,
        icon: ManuallyIcon,
        label: 'Install events using code',
        labelId: 'tracking.setup.modal.conversion.label',
        subtext:
            'Manually install events by pasting the code snippet below on your web page section of your website code.',
    },
];

const TrackingSetupMethodRadioItem = ({ id, Icon, label, subtext, badgeComponent, labelId }) => (
    <div className={styles['radio-container']}>
        <div className={styles['icon-wrapper']}>
            <Icon />
        </div>
        <div className={styles['label-container']}>
            <div className={styles['label-header']}>
                <FormattedMessage id={labelId} tagName="h4" defaultMessage={label} />
                {badgeComponent}
            </div>
            <span className={styles['desc']}>
                <FormattedMessage id={`tracking.setup.modal.${id}.description`} defaultMessage={subtext} />
            </span>
        </div>
    </div>
);

export const TrackingSetupCodelessConversionMethodRadioGroup = ({ type, setType }) => {
    const options = useAvailableItems(configs);

    return (
        <RadioGroup
            id="tracking_setup_method_radio_group"
            name="tracking_setup_method_radio_group"
            selectedValue={type}
            onChange={setType}
            className={styles['group']}
        >
            {options.map(({ id, icon: Icon, label, subtext, badgeComponent, labelId }) => {
                return (
                    <Radio key={id} value={id} labelClassName={styles['radio']} title="">
                        <TrackingSetupMethodRadioItem
                            id={id}
                            Icon={Icon}
                            label={label}
                            subtext={subtext}
                            badgeComponent={badgeComponent}
                            labelId={labelId}
                        />
                    </Radio>
                );
            })}
        </RadioGroup>
    );
};

export default TrackingSetupCodelessConversionMethodRadioGroup;
